module.exports = __webpack_public_path__ + "img/7.29eb6a61.jpg";